import { Navigate, useLocation, useParams } from "react-router-dom";

import { useCan } from "../auth/use-can";

/**
 * **Where an old address lands since the module structure** (MS-D3, 2026-10-16).
 *
 * `/staff` was one page with tabs; HR is four pages now. Somebody who sees the
 * team lands on Shifts, as the old page opened on its schedule for them; anybody
 * else on Me, as it opened on their own record.
 */
export function HrIndex(): React.JSX.Element {
  const can = useCan();
  // The day and the person ride along: an old `/staff?day=…` link still opens that day.
  const { search } = useLocation();
  return <Navigate to={`${can("hr.team.view") ? "/hr/shifts" : "/hr/me"}${search}`} replace />;
}

/** `/settings/people/:userId` → `/people/staff/:userId`, keeping the person. */
export function PersonRedirect(): React.JSX.Element {
  const { userId } = useParams<{ userId: string }>();
  return <Navigate to={`/people/staff/${userId ?? ""}`} replace />;
}
